exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sign-in__form {\r\n  max-height: -webkit-fit-content!important;\r\n  max-height: -moz-fit-content!important;\r\n  max-height: fit-content!important;\r\n  overflow: scroll;\n}\n.sign-in__aside {\r\n  position: sticky!important;\r\n  top: 0!important;\n}\r\n", ""]);

// exports
